import Vue from 'vue';
import Meta from 'vue-meta';
import App from './App.vue';
import router from './router';
import '@/assets/styles/index.css';
import '@/assets/styles/fonts.pcss';
import '@/assets/styles/transitions.pcss';
import '@/assets/styles/reset.pcss';
import InsightsLoading from '@/components/ui/InsightsLoading';

Vue.config.productionTip = false;

Vue.component('InsightsLoading', InsightsLoading);

Vue.use(Meta);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
